/** Blurred map stand-in (design asset): never the user's own fields and no Google request, so it shows before the Experience consent. */
export const MAP_PLACEHOLDER_IMAGE = "/images/misc/map-placeholder.png";

/** Side of a Google Maps tile; a custom map layer tiles the same way. */
export const GOOGLE_MAPS_TILE_SIZE_PX = 256;

/** Upper zoom of a custom map layer: beyond every Google zoom, so the layer never drops out. */
export const MAP_LAYER_MAX_ZOOM = 25;

/** The Earth's radius as Google's map projection uses it. */
export const EARTH_RADIUS_M = 6378137;
